import React from 'react';
import styled from 'styled-components';
import {SkeletonBlock} from '../../../../atoms/Skeletons/SkeletonBlock';

export const BasketItemSkeleton = () => {
  return (
    <BasketItemWrapper>
      <BasketItemDetailsThumb>
        <SkeletonBlock $width="100%" $height="160px" disableSpaceBelow />
      </BasketItemDetailsThumb>
      <BasketDetailsColumn>
        <BasketItemDetailsSkeleton>
          <SkeletonBlock $width="40%" $height="20px" />
          <SkeletonBlock $width="10%" $height="20px" />
        </BasketItemDetailsSkeleton>
        <SkeletonBlock $width="20%" $height="20px" />
        <SkeletonBlock $width="10%" $height="20px" />
      </BasketDetailsColumn>
    </BasketItemWrapper>
  );
};

const BasketItemWrapper = styled.div`
  display: flex;
  gap: 20px;
  padding: 1.5rem 0;
`;

const BasketItemDetailsThumb = styled.div`
  flex-basis: 145px;
`;

const BasketDetailsColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
`;

const BasketItemDetailsSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1 1 0;
`;
